export default __webpack_public_path__ + "static/media/alumini (8).953146b4.jpg";